namespace GeniuzPOS.RefundReasonReport {
    export namespace ReportRefundReasonByBillService {
        export const baseUrl = 'RefundReasonReport/ReportRefundReasonByBill';

        export declare function Create(request: Serenity.SaveRequest<ReportRefundReasonByBillRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ReportRefundReasonByBillRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportRefundReasonByBillRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportRefundReasonByBillRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "RefundReasonReport/ReportRefundReasonByBill/Create",
            Update = "RefundReasonReport/ReportRefundReasonByBill/Update",
            Delete = "RefundReasonReport/ReportRefundReasonByBill/Delete",
            Retrieve = "RefundReasonReport/ReportRefundReasonByBill/Retrieve",
            List = "RefundReasonReport/ReportRefundReasonByBill/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportRefundReasonByBillService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
